import React, { ReactElement } from 'react';
import { useApolloClient, ApolloClient } from '@apollo/client';
import { NormalizedCacheObject } from '@apollo/client/cache';
import { getPreloadedImages } from '@catalogo/core-preload-images';

export const PreloadedImages = (): (ReactElement | null)[] => {
  const client = useApolloClient() as ApolloClient<NormalizedCacheObject>;
  const images = getPreloadedImages(client);

  return images.map(image => <link key={image} rel="preload" as="image" href={image} />);
};
